import script from "./sendCard.vue?vue&type=script&setup=true&lang=js"
export * from "./sendCard.vue?vue&type=script&setup=true&lang=js"

import "./sendCard.vue?vue&type=style&index=0&id=4147ff6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4147ff6b"]])

export default __exports__